import { NAME } from './constants';

export const BULK_UPDATE_ITEMS = `${NAME}/BULK_UPDATE_ITEMS`;
export const BULK_UPDATE_ITEMS_FAILURE = `${NAME}/BULK_UPDATE_ITEMS_FAILURE`;
export const BULK_UPDATE_ITEMS_SUCCESS = `${NAME}/BULK_UPDATE_ITEMS_SUCCESS`;

export const FETCH_PRODUCTS = `${NAME}/FETCH_PRODUCTS`;
export const FETCH_PRODUCTS_FAILURE = `${NAME}/FETCH_PRODUCTS_FAILURE`;
export const FETCH_PRODUCTS_SUCCESS = `${NAME}/FETCH_PRODUCTS_SUCCESS`;

export const DUPLICATE_PRODUCT = `${NAME}/DUPLICATE_PRODUCT`;
export const DUPLICATE_PRODUCT_FAILURE = `${NAME}/DUPLICATE_PRODUCT_FAILURE`;
export const DUPLICATE_PRODUCT_SUCCESS = `${NAME}/DUPLICATE_PRODUCT_SUCCESS`;

export const SAVE_ITEM = `${NAME}/SAVE_ITEM`;
export const SAVE_ITEM_FAILURE = `${NAME}/SAVE_ITEM_FAILURE`;
export const SAVE_ITEM_SUCCESS = `${NAME}/SAVE_ITEM_SUCCESS`;
